// VFX: Notification Toast Stack
// Category: notification-toasts  ·  Tags: ui, notification, toast, stack, sales
// Toast notifications cascading in.
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
const clamp = {extrapolateLeft:"clamp",extrapolateRight:"clamp"} as const;
type Toast = {icon?:string; title:string; subtitle?:string; color?:string};
export const NotificationToastStack: React.FC<{
  toasts?: Toast[]; staggerFrames?: number; position?: "top"|"center"|"bottom";
}> = ({
  toasts=[
    {icon:"💰",title:"Venda realizada",subtitle:"R$ 1.497 — Plano Pro",color:"#34d399"},
    {icon:"👤",title:"Novo lead",subtitle:"João S. preencheu o form",color:"#60a5fa"},
    {icon:"⭐",title:"5 estrelas",subtitle:'"Melhor decisão que tomei"',color:"#fbbf24"},
  ],
  staggerFrames=18, position="center"
}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();
  const justifyMap = {top:"flex-start", center:"center", bottom:"flex-end"};
  return (
    <AbsoluteFill style={{justifyContent:justifyMap[position], alignItems:"center", padding:"80px 30px", flexDirection:"column", gap:16}}>
      {toasts.map((toast,i) => {
        const delay = i * staggerFrames;
        const p = spring({frame:frame-delay, fps, config:{damping:140, stiffness:200}});
        if(frame < delay) return null;
        return (
          <div key={i} style={{
            width:520, opacity:p,
            transform:`translateY(${interpolate(p,[0,1],[-24,0],clamp)}px) scale(${interpolate(p,[0,1],[0.9,1],clamp)})`,
          }}>
            <div style={{
              display:"flex", alignItems:"center", gap:16, padding:"16px 20px",
              borderRadius:16, background:"rgba(20,20,24,0.92)",
              backdropFilter:"blur(20px)",
              border:`1px solid ${toast.color||"#6366f1"}33`,
              boxShadow:`0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04), 0 0 24px ${toast.color||"#6366f1"}22`,
            }}>
              {toast.icon && <div style={{fontSize:28, flexShrink:0}}>{toast.icon}</div>}
              <div style={{flex:1}}>
                <div style={{fontSize:16, fontWeight:600, color:"#f0f0f0", fontFamily:"system-ui", marginBottom:2}}>{toast.title}</div>
                {toast.subtitle && <div style={{fontSize:13, color:"rgba(255,255,255,0.5)", fontFamily:"system-ui"}}>{toast.subtitle}</div>}
              </div>
              <div style={{width:8, height:8, borderRadius:"50%", background:toast.color||"#6366f1", flexShrink:0, boxShadow:`0 0 8px ${toast.color||"#6366f1"}`}} />
            </div>
          </div>
        );
      })}
    </AbsoluteFill>
  );
};

export default function UiNotificationToastStack800Ms() {
  return <NotificationToastStack />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
